import { SuppliersContext } from 'Context/SuppliersContext';
import { SUPPLIER_RESULT_FILTER, SUPPLIERS_ID } from 'Enum/suppliers';
import { useContext } from 'react';

export const useSuppliersDispatchType = () => {
  const { suppliersId } = useContext(SuppliersContext);

  const getDispatchType = () => {
    switch (suppliersId) {
      default:
      case SUPPLIERS_ID.mentalTherapy:
        return SUPPLIER_RESULT_FILTER.Therapy;
      case SUPPLIERS_ID.doctors:
        return SUPPLIER_RESULT_FILTER.doctors;
    }
  };

  return getDispatchType();
};
